<template>
  <div>
    <div class="v2-w-full">
      <div class="v2-w-full">
        <V2CartActions
          :cart-list="cartList"
          :cart-values-list="cartValuesList"
          :total-order-value="totalOrderValue"
        />
      </div>
      <!-- carts total -->
      <div class="v2-w-full v2-mt-4">
        <V2CartsTotal
          :cart-list="cartList"
          :cart-values-list="cartValuesList"
          :total-order-value="totalOrderValue"
          :on-place-order-success="loadCarts"
        />
      </div>
      <!-- cart list -->
      <V2Card class="v2-w-full v2-mt-4 v2-retailer-carts__card">
        <V2RetailerCartList
          :cart-list="cartList"
          :load-carts="loadCarts"
          @get-cart-values-list="getCartValuesList"
        />
      </V2Card>
    </div>
  </div>
</template>

<script>
import { constants as c } from '@kingpin-global/kingpin-utils-frontend'
import { mapState } from 'vuex'
import analytics from '@/@core/utils/analytics'
import constants from '@/constants'
import V2Card from '@/components/v2/V2Card.vue'
import V2RetailerCartList from './V2RetailerCartList.vue'
import V2CartsTotal from './V2CartsTotal.vue'
import V2CartActions from './V2CartActions.vue'

const { CURRENCY_CONVERSIONS } = c

export default {
  name: 'V2RetailerCarts',
  components: {
    V2CartsTotal,
    V2RetailerCartList,
    V2Card,
    V2CartActions,
  },
  props: {
    loadCarts: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      cartValuesList: [],
      totalOrderValue: {
        totalCartsValue: 0,
        totalCartsUnits: 0,
        totalCartsRRP: 0,
        currency: CURRENCY_CONVERSIONS.USD.SYMBOL,
      },
    }
  },
  computed: {
    ...mapState({
      cartList: state => state.checkout.carts,
    }),
  },
  mounted() {
    analytics.track(constants.TRACKS.PAGES.RETAILER_OPENS_CART_WITH_MULTIPLE_STORES, { cartList: this.cartValuesList })
  },
  methods: {
    calculateTotalValues(list) {
      this.totalOrderValue.currency = list[0]?.currency || CURRENCY_CONVERSIONS.USD.SYMBOL
      this.totalOrderValue.totalCartsValue = list.reduce((acc, val) => acc + Number(val.totalValues), 0)
      this.totalOrderValue.totalCartsUnits = list.reduce((acc, val) => acc + Number(val.totalUnits), 0)
      this.totalOrderValue.totalCartsRRP = list.reduce((acc, val) => acc + Number(val.totalRRP), 0)
    },
    getCartValuesList(cartValuesList) {
      this.cartValuesList = cartValuesList
      this.calculateTotalValues(cartValuesList)
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-retailer-carts__card {
  ::v-deep .v2-card__body {
    padding: 0;
  }
}
</style>
